
const isSmallDevice = function () {
  return window.matchMedia('(max-width: 640px)').matches
}

export {
  isSmallDevice
}
